import { useEffect, useState } from 'react';
import { isNull } from 'lodash-es';
import { Card } from '../../api/bankCard/types';

export const useBCSelectedCard = (
  isCardsLoaded: boolean,
  cardList: Card[] | null
) => {
  const [selectedCard, setSelectedCard] = useState<Card | null>(null);

  useEffect(() => {
    // Once cardList loaded it should set first item as an active card
    const setInitialCardItem = () => {
      const initialItem = isCardsLoaded && cardList?.length && cardList[0];
      if (initialItem) {
        setSelectedCard(initialItem);
      }
    };
    if (isNull(selectedCard)) {
      setInitialCardItem();
    }
  }, [selectedCard, cardList, isCardsLoaded]);

  return {
    selectedCard,
    setSelectedCard
  };
};
